import { render, staticRenderFns } from "./Draws.vue?vue&type=template&id=242109e5&scoped=true&"
import script from "./Draws.vue?vue&type=script&lang=js&"
export * from "./Draws.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242109e5",
  null
  
)

export default component.exports